import * as Html from "../util/Html.ts";
export {init}
Html.registerWidget('widget/video-load-detector',{init:init})

function init(node){
  node.get(0).onloadedmetadata  = function(){
    node.trigger('afterupdate',node.height());
  }
}